import channel from 'api/axios/foka/channel'
import restrictionIp from 'api/axios/foka/restrictionIp'
import ad from 'api/axios/foka/ad'
import tracker from 'api/axios/foka/tracker'
import creative from 'api/axios/foka/creative'
import document from 'api/axios/foka/document'
import dashboard from 'api/axios/foka/dashboard'
import editlog from 'api/axios/foka/editlog'
import report from 'api/axios/foka/report'
import image from 'api/axios/foka/image'
import bulk from 'api/axios/foka/bulk'
import recommendKeyword from 'api/axios/foka/recommendKeyword'

const api = {
  dashboard,
  ad,
  tracker,
  channel,
  restrictionIp,
  document,
  creative,
  editlog,
  report,
  image,
  bulk,
  recommendKeyword,
  response: data => Promise.resolve({ data }),
}

export default api
